import { z } from 'zod'

import { Ability } from 'common/core/constants/Ability'
import { makeGuardFromSchema } from 'shared/api/requests/utils'

import { AbilitiesUnsafeMapSchema, CommonAbilityNames, LimitBasedAbilityNames } from './schemas'

export const isAbilitiesUnsafeMap = makeGuardFromSchema(AbilitiesUnsafeMapSchema)

export const isString = makeGuardFromSchema(z.string())

const LimitBasedAbilities = [
  Ability.CHANNELS_COUNT,
  Ability.USERS_TOTAL,
  Ability.LIVECHAT_SEATS,
  Ability.VIEWERS,
] as const

export const isCommonAbility = (ability: Ability): ability is CommonAbilityNames => {
  return !LimitBasedAbilities.includes(ability as Ability.CHANNELS_COUNT)
}

export const isLimitBasedAbility = (ability: Ability): ability is LimitBasedAbilityNames => {
  return LimitBasedAbilities.includes(ability as Ability.VIEWERS)
}
